import { BillStatus } from "@redotech/crdb-enums/billing/bill-status";
import {
  BILL_DATE_PARAM,
  lastMonthsSelection,
  serializeBillDateSelection,
} from "@redotech/redo-billing-common/billing/bill-date-selection";
import { PRODUCT_ENTRY_MONTHS } from "@redotech/redo-billing-common/billing/bills-link";
import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import {
  BillingTab,
  getBillingPageLink,
} from "@redotech/redo-merchant-links/links";
import { BILL_FILTERS_PARAM, encodeBillFilters } from "./bill-filter-params";

// A decline can sit unpaid a while before the merchant reads the banner, so
// reach back further — an empty table is the dead end this link exists to avoid.
const FAILED_ENTRY_MONTHS = 12;

function billsLink(
  teamId: string,
  now: Date,
  months: number,
  filters: { products?: SubscriptionProduct[]; statuses?: BillStatus[] },
): string {
  const params = new URLSearchParams({
    [BILL_DATE_PARAM]: serializeBillDateSelection(
      lastMonthsSelection(now, months),
    ),
  });
  const encoded = encodeBillFilters(filters);
  if (encoded) {
    params.set(BILL_FILTERS_PARAM, encoded);
  }
  return `${getBillingPageLink(teamId, BillingTab.BILLS)}?${params.toString()}`;
}

/** Bills, scoped to one product's invoices — a product billing page's entry. */
export function productBillsLink(
  teamId: string,
  products: SubscriptionProduct[],
  now: Date,
): string {
  return billsLink(teamId, now, PRODUCT_ENTRY_MONTHS, { products });
}

/**
 * Bills, scoped to the invoices that actually failed to collect — the bill the
 * failed-payment banner is complaining about.
 */
export function failedBillsLink(teamId: string, now: Date): string {
  return billsLink(teamId, now, FAILED_ENTRY_MONTHS, {
    statuses: [BillStatus.Failed],
  });
}
